import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";
import Products from "../Product/Products";
import ProductCategory from "../ProductCategory/ProductCategory";
import JewelleryList from "../JewelleryList/JewelleryList";
import AccessControl from "../../Comman/AccessControl";
import { controlAllFeatureOptions } from "../../../configs/constants";
import { canShowPermission } from "../Permissions/permissionObject";
import { useEffect } from "react";
import InfoButton from "../../Comman/InfoButton";

export default function ProductsManagementPage() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const canViewProducts = canShowPermission(permissions, "products", "view");
  const canViewProductCategory = canShowPermission(permissions, "productCategory", "view");
  const canViewJewellery =
    canShowPermission(permissions, "jewellery", "view");

  const tabs = [
    canViewProducts && {
      label: t("tabs.products"),
      content: <Products />
    },
    canViewProductCategory && {
      label: t("tabs.category"),
      content: <ProductCategory />
    },
    canViewJewellery && {
      label: t("tabs.jewellery"),
      content: <JewelleryList />
    },
  ]
  .filter(Boolean);

  useEffect(() => {
    if (tabIndex > tabs.length - 1) {
      setTabIndex(0);
    }
  }, [tabIndex, tabs.length]);

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            width: "100%",
            mt: { xs: 10, md: 10 },
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
        <Paper
          sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }}
          elevation={1}
        >
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            variant="fullWidth"
            sx={{
              mb: 0,
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              padding: "4px",
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "16px",
                textTransform: "none",
                borderRadius: "6px",
                margin: "0 4px",
                minHeight: "48px",
                "&.Mui-selected": {
                  backgroundColor: "#fff",
                  color: "#7A3FFF",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  borderBottom: "3px solid #7A3FFF",
                },
                "&:hover": {
                  backgroundColor: "rgba(122, 63, 255, 0.08)",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
          <Box sx={{ mt: 0 }}>
            {tabs[tabIndex]?.content}
          </Box>
          
        </Paper>
      </Box>
      <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="PRODUCT_MANAGEMENT" />
  </Box>
    </Box>
    </Box>
  );
}

